<template>
  <el-aside class="menu_panel" style="width:15.5rem;height:calc(100vh - 3rem);">
    <el-menu class="menu" :default-active="activeIndex" :router="true" :collapse="false">
      <template v-for="item in menu">
        <template v-if="item.children">
          <el-submenu :key="item.path" :index="item.path">
            <template slot="title">
              <i class="icon iconfont" v-bind:class="item.icon"></i>
              <span>{{ item.title }}</span>
            </template>
            <el-menu-item v-for="subItem in item.children" :key="subItem.path" :index="subItem.path">
              {{ subItem.title }}
            </el-menu-item>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :key="item.path" :index="item.path">
            <i class="icon iconfont" v-bind:class="item.icon"></i>
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </el-aside>
</template>
<script>
import menuList from "@/components/public/menu.js";
import { mapState } from "vuex";
export default {
  props: {
    active: String
  },
  data() {
    return {
      activeIndex: ""
    };
  },
  computed: {
    ...mapState({
      menu: function(state) {
        let _role = state.role;
        /**处理省市操作员，显示省市页面，项目中心操作员显示项目中心页面 */
        return menuList[_role];
      }
    })
  },
  methods: {
    findFristMenu() {
      /**当前用户的第一个可以点击的菜单 */
      let firstMenu = "";
      let active = this.active;
      let menu = this.menu;
      for (let i = 0; i < menu.length; i++) {
        let item = menu[i];
        if (0 == i) {
          firstMenu = item.path;
        }
        if (active == item.path) {
          active = item.path;
          break;
        }
        if (item.children) {
          for (let j = 0; j < item.children.length; j++) {
            let subItem = item.children[i];
            /**如果第一个子菜单可以点击，替换为子菜单 */
            if (0 == j && 0 == i) {
              firstMenu = subItem.path;
              /**当前active不存在时,直接返回 */
              if (!active) break;
            }
            if (active == subItem.path) {
              active = subItem.path;
              break;
            }
          }
          break;
        }
      }
      /**没有指定组件的默认菜单，使用第一个菜单*/
      return active ? active : firstMenu;
    }
  },
  created() {
    let path = this.$route.path;
    if (path === "/management") {
      this.activeIndex = this.findFristMenu();
      this.$router.push(this.activeIndex);
    } else {
      this.activeIndex = this.$route.meta.index;
    }
  }
};
</script>
<style scoped lang="scss">
.menu_panel {
  font-size: 0.88rem;
  font-weight: 400;
  .menu {
    height: 100%;
  }
}
</style>
